import React, { useContext } from 'react';
import {
  Button,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FormattedMessage } from 'react-intl';
import {
  MailIcon,
  PhoneIcon,
  CommentDotsIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import { formatPhoneNumber } from '@fortress-technology-solutions/fortress-component-library/utils';
import { AppContext } from 'contexts/AppContext';

const ContactUs = () => {
  const {
    marketingInfo: { propertyEmail, phoneNumber, textingPhoneNumber },
  } = useContext(AppContext);

  return (
    <Stack
      direction={'column'}
      spacing={1}
      sx={{
        maxWidth: { xs: '100%', sm: 'calc(100% - 128px)' },
        margin: 'auto',
      }}
    >
      <Typography
        align="center"
        color="text.secondary"
        variant="bodyLarge"
        mb={1}
      >
        <FormattedMessage id="afforda.dashboard.contact" />
      </Typography>
      {phoneNumber && (
        <Button
          variant="secondary"
          startIcon={<PhoneIcon />}
          sx={{ minWidth: 250 }}
          href={`tel:${phoneNumber}`}
        >
          {formatPhoneNumber(phoneNumber)}
        </Button>
      )}
      {textingPhoneNumber && (
        <Button
          variant="secondary"
          startIcon={<CommentDotsIcon />}
          sx={{ minWidth: 250 }}
          href={`sms:${textingPhoneNumber}`}
        >
          {formatPhoneNumber(textingPhoneNumber)}
        </Button>
      )}
      <Button
        variant="secondary"
        startIcon={<MailIcon />}
        sx={{ minWidth: 250 }}
        href={'mailto:' + propertyEmail}
      >
        {propertyEmail}
      </Button>
    </Stack>
  );
};

export default ContactUs;
